import { InputHTMLAttributes, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

require('./RadioField.css');

// TODO: Clean this up (don't have nested input object) once we get rid of redux-form

export type Props = {
    id: string;
    className?: string;
    required?: boolean;
    label?: string | ReactNode;
    labelKey?: string;
    input: InputHTMLAttributes<HTMLInputElement> & any;
    myValue: string;
    toolTipKey?: string;
};

export const RadioField = ({ id, required, input, myValue, labelKey, label, toolTipKey }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={ `${required ? 'required' : ''} ui radio checkbox field` }>
            <input
                id={ id }
                type="radio"
                { ...input }
                value={ myValue }
                checked={ input.value == myValue }
            />
            <label htmlFor={ id }>
                { label || t(labelKey!) }
                { toolTipKey &&
                    <span className="_tooltip">
                        <i
                            className="ui small grey open question circle outline icon"
                            title={ t(toolTipKey) }
                        />
                    </span>
                }
            </label>
        </div>
    );
};
